module.exports = __webpack_public_path__ + "img/logo-salon-metier-2026.5a768ba3.svg";